import styled from '@emotion/styled';
import ArrowRight from '~/icons/iconography/arrow/right.svg';
import { Link as GenericLink } from '~/shared/components/Link';
import { breakpoints } from '~/theme';

export const Categories = styled.ul(({ theme }) => ({
    '--columns': 2,
    '--gap': `${theme.space[3]} 6px`,

    display: 'grid',
    gridTemplateColumns: 'repeat(var(--columns), minmax(0, 1fr))',
    gap: 'var(--gap)',
    marginBottom: theme.space[3],

    [breakpoints.md]: {
        '--columns': 3,
        '--gap': `${theme.space[5]} ${theme.space[2]}`,
        marginBottom: theme.space[6],
    },
}));

export const Link = styled(GenericLink)(({ theme }) => ({
    position: 'relative',
    fontSize: theme.fontSizes.beetle,

    [`:hover ${Arrow}, :focus ${Arrow}, :active ${Arrow}`]: {
        transform: 'rotate(-45deg)',
    },
}));

export const Text = styled.span({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
});

export const Name = styled.span(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.space[2],
    fontSize: theme.fontSizes.mouse,
    fontWeight: theme.fontWeights.medium,
    lineHeight: theme.lineHeights.rat,

    [breakpoints.md]: {
        marginTop: theme.space[3],
    },
}));

export const Arrow = styled(ArrowRight)(({ theme }) => ({
    display: 'block',
    flexShrink: 0,
    height: 18,
    width: 18,
    marginLeft: theme.space[3],
    transition: 'transform 150ms cubic-bezier(.25,.46,.45,.94)',
}));

export const ImageWrapper = styled.div({
    position: 'relative',
    aspectRatio: '70/45',
});
